<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-3">Abbreviations</h1>
<table class="table">
<tbody>
<tr>
<td class="w15"><p class="t-left">AB</p></td>
<td class="w80"><p class="t-left">Anchor Bible</p></td>
</tr>
<tr>
<td class="w15"><p class="t-left">ca.</p></td>
<td class="w80"><p class="t-left">circa</p></td>
</tr>
<tr>
<td class="w15"><p class="t-left">cf.</p></td>
<td class="w80"><p class="t-left">compare</p></td>
</tr>
<tr>
<td class="w15"><p class="t-left">ch(s).</p></td>
<td class="w80"><p class="t-left">chapter(s)</p></td>
</tr>
<tr>
<td class="w15"><p class="t-left">CC</p></td>
<td class="w80"><p class="t-left">Continental Commentaries</p></td>
</tr>
<tr>
<td class="w15"><p class="t-left">ConcC</p></td>
<td class="w80"><p class="t-left">Concordia Commentary</p></td>
</tr>
<tr>
<td class="w15"><p class="t-left"><em>CTJ</em></p></td>
<td class="w80"><p class="t-left"><em>Calvin Theological Journal</em></p></td>
</tr>
<tr>
<td class="w15"><p class="t-left">d.</p></td>
<td class="w80"><p class="t-left">died</p></td>
</tr>
<tr>
<td class="w15"><p class="t-left">Eng.</p></td>
<td class="w80"><p class="t-left">English</p></td>
</tr>
<tr>
<td class="w15"><p class="t-left">ESV</p></td>
<td class="w80"><p class="t-left">English Standard Version</p></td>
</tr>
<tr>
<td class="w15"><p class="t-left"><em>EvQ</em></p></td>
<td class="w80"><p class="t-left"><em>Evangelical Quarterly</em></p></td>
</tr>
<tr>
<td class="w15"><p class="t-left">Heb.</p></td>
<td class="w80"><p class="t-left">Hebrew</p></td>
</tr>
<tr>
<td class="w15"><p class="t-left"><em>JETS</em></p></td>
<td class="w80"><p class="t-left"><em>Journal of the Evangelical Theological Society</em></p></td>
</tr>
<tr>
<td class="w15"><p class="t-left">JSOTSup</p></td>
<td class="w80"><p class="t-left"><em>Journal for the Study of the Old Testament</em> Supplement Series</p></td>
</tr>
<tr>
<td class="w15"><p class="t-left">LXX</p></td>
<td class="w80"><p class="t-left">Septuagint</p></td>
</tr>
<tr>
<td class="w15"><p class="t-left">MT</p></td>
<td class="w80"><p class="t-left">Masoretic Text</p></td>
</tr>
<tr>
<td class="w15"><p class="t-left">n(n).</p></td>
<td class="w80"><p class="t-left">note(s)</p></td>
</tr>
<tr>
<td class="w15"><p class="t-left">NAC</p></td>
<td class="w80"><p class="t-left">New American Commentary</p></td>
</tr>
<tr>
<td class="w15"><p class="t-left">NASB</p></td>
<td class="w80"><p class="t-left">New American Standard Bible (1995)</p></td>
</tr>
<tr>
<td class="w15"><p class="t-left">NIV</p></td>
<td class="w80"><p class="t-left">New International Version (2011)</p></td>
</tr>
<tr>
<td class="w15"><p class="t-left">NIVAC</p></td>
<td class="w80"><p class="t-left">NIV Application Commentary</p></td>
</tr>
<tr>
<td class="w15"><p class="t-left">NJB</p></td>
<td class="w80"><p class="t-left">New Jerusalem Bible</p></td>
</tr>
<tr>
<td class="w15"><p class="t-left">NJPS</p></td>
<td class="w80"><p class="t-left">New Jewish Publication Society of America Tanakh</p></td>
</tr>
<tr>
<td class="w15"><p class="t-left">NRSV</p></td>
<td class="w80"><p class="t-left">New Revised Standard Version</p></td>
</tr>
<tr>
<td class="w15"><p class="t-left">OT</p></td>
<td class="w80"><p class="t-left">Old Testament</p></td>
</tr>
<tr>
<td class="w15"><p class="t-left">p(p).</p></td>
<td class="w80"><p class="t-left">page(s)</p></td>
</tr>
<tr>
<td class="w15"><p class="t-left">TOTC</p></td>
<td class="w80"><p class="t-left">Tyndale Old Testament Commentaries</p></td>
</tr>
<tr>
<td class="w15"><p class="t-left">v(v)</p></td>
<td class="w80"><p class="t-left">verse(s)</p></td>
</tr>
<tr>
<td class="w15"><p class="t-left">WBC</p></td>
<td class="w80"><p class="t-left">Word Biblical Commentary</p></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 009_Abbreviations.vue?6e927afd